import React from "react";
import {useState} from "react";
import {useSelector} from "react-redux";
import "../../assets/css/pages/categories.css";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import swal from 'sweetalert';
import CategoryTreeComponent from "./CategoryTreeComponent";

export default function ({
                             category,
                             indexCategory,
                             triggerCategoriesLoop,
                         }) {

    const navigate = useNavigate();
    const token = useSelector(state => state.token);
    const [showChildren, setShowChildren] = useState(false);
    const [isActive, setIsActive] = useState(category?.is_active);
    const [actionsOpen, setActionsOpen] = useState(false);

    const toggleActiveStatus = (id) => {
        axios.get('category-is-active-toggle/' + id).then((res) => {
            setIsActive(!isActive);
        }).catch(function (error) {
        });
    }


    const loopChildren = (array) => {
        return array.map((item, index) =>
            <CategoryTreeComponent
                indexCategory={index}
                category={item}
                triggerCategoriesLoop={triggerCategoriesLoop}
            />
        )
    }


    const deleteCategory = (id, name) => {
        swal({
            title: "Are you sure?",
            text: 'You want to delete category "' + name + '"?',
            icon: "warning",
            buttons: true,
            dangerMode: true,
            confirm: {
                text: "Yes",
                value: true,
                visible: true,
                className: "",
                closeModal: true
            }
        }).then((result) => {
            console.log(result);
            if (result == true) {
                axios.delete('categories/' + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                }).then(function (res) {
                    console.log(res);
                    if (res.status == 200 && res.data?.status) {
                        swal('The category "' + name + '" has been deleted!', {
                            icon: "success",
                        });
                        triggerCategoriesLoop(id);
                        setActionsOpen(false);
                        return true;
                    } else {
                        return false;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            }
        });
    }

    return (
        <div key={indexCategory} className={`row tr${actionsOpen ? " bg-main-color" : ""}`}>
            <div className="col-1 pt-4">
                <button
                    onClick={() => {
                        setShowChildren(!showChildren)
                    }}
                    className={`btn expand fs-4${category?.children.length == 0 ? " d-none" : ""}
            ${showChildren ? " bg-primary" : "btn-secondary"}`}
                    title={showChildren ? "Close Children" : "Show Children"}
                >
                    {showChildren ? <i className="fas fa-minus text-white"></i> :
                        <i className="fas fa-plus text-white"></i>}
                </button>
            </div>
            <div className="col-1 text-muted pt-5">
                {category?.id}
            </div>
            <div className="col-2 text-muted pt-5">
                {category?.name}
            </div>
            <div className="col-1 pt-2">
                {category?.children.length != 0 ? //if Has Subcategories
                    <div
                        className="btn btn-bg-white d-inline-block br-0-95-rem py-3 px-4 text-center rounded disabled opacity-50 fs-8"
                        title="Has Subcategories"
                    >
                        <i className="far fa-times-circle fs-1"></i>
                    </div> : ""}
                {category?.children.length == 0 ? ////if Has NOT Subcategories
                    <div
                        className="btn btn-white d-inline-block br-0-95-rem py-3 px-4 text-center rounded opacity-100 fs-7"
                        title="Click to open this category attributes page"
                        onClick={() => {
                            navigate(`/categories/${category?.id}/attributes`)
                        }}
                    >
                        <span className="fw-bolder fs-7 ls-1">{category?.attributes.length}</span>
                    </div> : ""}
            </div>
            <div className="col-2 text-muted pt-5 fs-7">
                {category?.code}
            </div>
            <div className="col-1 text-muted text-center pt-5 fs-7">
                {category?.products_count || 0}
            </div>
            <div className="col-2 px-2 pt-4">
                <div className="active-notactive pl-0">
                    <label className="form-check form-switch form-check-custom form-check-solid">
                        <input className="form-check-input active-block"
                               type="checkbox"
                               value="1"
                               defaultChecked={isActive}
                               onClick={() => toggleActiveStatus(category?.id)}
                        />
                        <span className="form-check-label fw-bold text-muted fs-8">
                            {isActive ? "Active" : "Blocked"}
                          </span>
                    </label>
                </div>
            </div>

            <div className="col-2 pt-4 pb-0">
                <button type="button"
                        className="btn-primary me-2 mb-2 py-2 px-1 fs-7 actions"
                        onClick={() => {
                            setActionsOpen(!actionsOpen)
                        }}>
                    Actions
                    <i className="fas fa-caret-down p-0"></i>
                </button>
                <div className={`row-actions hidden-actions ${actionsOpen ? "" : "display-none"}`}>
                    <div className="absolute-div">
                        <button
                            className="btn btn-primary me-2 mb-4 mt-1 edit"
                            onClick={() => {
                                navigate(`/categories/${category?.id}/edit`);
                            }}
                        >
                            <i className="fas fa-edit"></i> Edit
                        </button>
                        {category?.children.length === 0 && <button
                            className="btn btn-primary me-2 mb-4 mt-1 attributes"
                            onClick={() => {
                                navigate(`/categories/${category?.id}/attributes`)
                            }}
                        >
                            <i className="fas fa-list"></i> Attributes
                        </button>}

                        <button
                            className="btn btn-danger me-2 mb-1 delete"
                            onClick={() => {
                                deleteCategory(category?.id, category?.name)
                            }}
                        >
                            <i className="far fa-trash-alt"></i> Delete
                        </button>
                    </div>
                </div>
            </div>

            <div className={`children${showChildren ? "" : " d-none"}`}>
                {category?.children.length != 0 ? loopChildren(category?.children) : ""}
            </div>
        </div>
    );
}